import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/cn.ts';

const badgeStyles = cva(
  'inline-flex items-center gap-1.5 rounded-pill px-2.5 py-1 text-2xs uppercase tracking-[0.16em] whitespace-nowrap',
  {
    variants: {
      variant: {
        neutral: 'bg-bg-raised text-fg-muted shadow-flat',
        accent: 'bg-accent/10 text-accent shadow-flat',
        v5rc: 'bg-program-v5rc/15 text-program-v5rc shadow-flat',
        viqrc: 'bg-program-viqrc/15 text-program-viqrc shadow-flat',
        vurc: 'bg-program-vurc/15 text-program-vurc shadow-flat',
        vairc: 'bg-program-vairc/15 text-program-vairc shadow-flat',
        success: 'bg-success/12 text-success shadow-flat',
        danger: 'bg-danger/12 text-danger shadow-flat',
      },
    },
    defaultVariants: { variant: 'neutral' },
  },
);

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeStyles>;

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeStyles({ variant }), className)} {...props} />;
}
